import { computed, defineComponent } from 'vue';
import girlPng from '@/assets/image/home/girl.png';
import boyPng from '@/assets/image/home/boy.png';
import { GRADE, SEX, value2label } from '@/utils';
export default defineComponent({
  name: 'UserInfoCard',
  props: {
    avatar: {
      type: String
    },
    name: {
      type: String
    },
    sex: {
      type: Number,
      default: 0
    },
    grade: {
      type: [String, Number],
      default: 0
    }
  },
  setup: function (props) {
    var sexText = computed(function () {
      return value2label(props.sex, SEX);
    });
    var sexPng = computed(function () {
      return props.sex === 2 ? girlPng : boyPng;
    });
    return {
      sexText: sexText,
      sexPng: sexPng,
      value2label: value2label,
      GRADE: GRADE
    };
  }
});